import React from 'react'

const Pluseicon = () => {
    return (
        <div>
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 32 32">
                <path id="plus-circle-solid" d="M34,18A16,16,0,1,1,18,2,16,16,0,0,1,34,18Zm-8.41-1.5H19.5V10.41a1.5,1.5,0,0,0-3,0V16.5H10.41a1.5,1.5,0,0,0,0,3H16.5v6.09a1.5,1.5,0,1,0,3,0V19.5h6.09a1.5,1.5,0,1,0,0-3Z" transform="translate(-2 -2)" fill="#475969" />
            </svg>
        </div>
    )
}

export default Pluseicon
